import { CS_NUMBER, DEFAULT_WHATSAPP_MESSAGE } from "@/constants";
import type { ServiceName } from "@/types/service";

import { sendAnalyticData } from "../monitoring/analytics";
import { embedTrackingUrl } from "../monitoring/oci";
import { handleWhatsappNumber } from "../platform";
import { getServiceLabel } from "../service/helpers";

export const onChatSales = ({
  path,
  includeTrackingUrl = false,
  message = DEFAULT_WHATSAPP_MESSAGE,
}: {
  path: string;
  includeTrackingUrl?: boolean;
  message?: string;
}) => {
  if (includeTrackingUrl) {
    message = embedTrackingUrl(message);
  }

  handleWhatsappNumber(CS_NUMBER, message);
  sendAnalyticData({
    name: "wa_sales_button_click",
    values: {
      path,
    },
  });
};

export const generateBookingChatSalesMessage = (service: ServiceName) => {
  return `Hi, I would like to chat about your ${getServiceLabel(service)} on your page https://app.luce.com/booking/${service}`;
};
